import { useMemo } from "react";

type BooleanKeys<T> = {
	[K in keyof T]-?: NonNullable<T[K]> extends boolean ? K : never;
}[keyof T];

export type PropertyOptionalParam<T> = {
	key: BooleanKeys<T>;
	label: string;
};

export type SharedBooleanKeys<TUnion> = (
	TUnion extends unknown
		? (keys: BooleanKeys<TUnion>) => void
		: never
) extends (keys: infer TShared) => void
	? TShared
	: never;

export const useGetPropertyOptionalParams = <T>(
	propTypes: PropertyOptionalParam<T>[],
	data: T,
	t: (key: string) => string,
): { properties: string } => {
	const properties = useMemo(
		() =>
			propTypes
				.filter(({ key }) => data[key])
				.map(({ label }) => t(label))
				.join(", "),
		[propTypes, data, t],
	);

	return { properties };
};
